interface AnyObject {
  [key: string]: any;
}

export function compareObjects(obj1: AnyObject, obj2: AnyObject): boolean {
  // Check if both objects are defined
  if (!obj1 || !obj2) {
    return false;
  }

  // Get the keys of the first object
  const keys = Object.keys(obj1);

  // Variable to track if any difference is found
  let isDifferent = false;

  // Iterate over the keys and compare the values
  for (const key of keys) {
    if (typeof obj1[key] === "string") {
      // Check if the key exists in both objects
      if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
        // Check if the values are not equal
        if (obj1[key] !== obj2[key]) {
          // Set the flag to true if a difference is found
          isDifferent = true;
        }
      } else {
        // If the key does not exist in one of the objects, set the flag to true
        isDifferent = true;
      }
    }
  }

  // Return true if any difference is found, otherwise return false
  return isDifferent;
}

export function allKeysHaveValues(obj: Record<string, any>): boolean {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === undefined || obj[key] === null || obj[key] === "") {
        return false;
      }
    }
  }
  return true;
}

export function getUpdatedFieldsFromObject(
  obj1: AnyObject,
  obj2: AnyObject
): { [key: string]: any } {
  // Check if both objects are defined
  if (!obj1 || !obj2) {
    return {};
  }

  // Get the keys of the first object
  const keys = Object.keys(obj1);

  // Object to store updated fields and their new values
  const updatedFields: { [key: string]: any } = {};

  // Iterate over the keys and compare the values
  for (const key of keys) {
    // Check if the key exists in both objects
    if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
      // Check if the values are not equal
      if (obj1[key] !== obj2[key]) {
        // Add the field name and its new value to the object of updated fields
        updatedFields[key] = obj1[key];
      }
    } else {
      // If the key does not exist in one of the objects, consider it updated
      updatedFields[key] = obj1[key];
    }
  }

  // Return the object of updated fields and their new values
  return updatedFields;
}
